import React, { useEffect, useRef } from "react";
import anime from "animejs";
import { ArrowRight } from "lucide-react";

const SeniorStaffChartSection = () => {
  const wavePathRef = useRef(null);

  useEffect(() => {
    anime({
      targets: wavePathRef.current,
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "easeInOutSine",
      duration: 3000,
      loop: false,
    });
  }, []);

  return (
    <div className="relative flex flex-col justify-center items-center py-16 overflow-hidden">
      <svg
        className="absolute top-0 left-0 w-full h-full z-0"
        viewBox="0 0 800 400"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="SvgjsLinearGradient1001">
            <stop stopColor="hsl(30, 100%, 50%)" offset="0" />
            <stop stopColor="hsl(30, 100%, 70%)" offset="1" />
          </linearGradient>
        </defs>

        <path
          ref={wavePathRef}
          d="M328.550048828125,10.76233196258545C358.25408447265625,44.125561256408695,451.8863684082031,58.36771430969239,452.3168640136719,149.77578735351562C452.74735961914064,241.18386039733886,359.6173205566406,333.58445922851564,330.3437805175781,391.6293029785156"
          fill="none"
          stroke="url(#SvgjsLinearGradient1001)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="2000"
        />
      </svg>

      <div className="absolute top-0 left-0 w-full h-full bg-sdorange opacity-20 z-10"></div>

      <div className="space-y-7 flex flex-col justify-center items-center relative z-20 px-4">
        <div className="relative z-20 bg-sdorange p-4 rounded border-2 border-white">
          <p className="text-2xl font-bold text-black">
            Senior Staff Organisation Chart
          </p>
        </div>

        <div className="relative z-20 bg-sdorange p-3 rounded border-2 border-white">
          <p className="text-left text-slate-700">
            View an organisation chart for senior management at the European
            School of Business & Diplomacy
          </p>
        </div>

        <div className="group relative z-20 border-2 border-sdorange bg-sdbodywhite p-3 rounded transition duration-300 hover:bg-black hover:text-white hover:border-white">
          <a
            href="/documents/ESBD_Organogram_WHO_IS_WHO.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between gap-3"
          >
            <p className="font-medium">View Senior Staff Organisation Chart</p>

            <ArrowRight
              aria-hidden="true"
              className="size-5 transition-transform duration-300 group-hover:translate-x-1"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SeniorStaffChartSection;
